// extracted by mini-css-extract-plugin
export default {"wrapper":"Dropdown_wrapper__mKy8M","item":"Dropdown_item__D+TK2","item_selected":"Dropdown_item_selected__Dedy4"};